import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { isNil } from 'shared/src/utils';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useFixedCouponSno } from '../hooks/useFixedCouponSno';
import { GoodsParamsContext } from '../context/GoodsParamsContext';

/**
 * PDP 상세 payload 는 상세설명 HTML(`detail_html`) 때문에 캐시 엔트리가 크다. 상품을 여러 개
 * 훑으면 goodsSno 마다 엔트리가 쌓여 gcTime 동안 힙에 남으므로, 기본값(5분)보다 짧게 잡는다.
 * (전역으로 낮추면 홈/마이페이지처럼 재방문이 잦은 캐시까지 버려져 역효과라 이 쿼리에만 적용)
 */
const GC_TIME_MS = 60_000;

export const useGoodsDetail = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  // 찜탭 등 route 밖 진입(logging 주입)에서는 카드 데이터로 로깅하므로 PDP 상세 API 를 호출하지 않는다.
  const injected = useContext(GoodsParamsContext);
  return useQuery({
    queryKey: queryKey.goodsDetail(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsDetail(goodsSno, fixedCouponSno),
    gcTime: GC_TIME_MS,
    enabled: isNil(injected?.logging),
  });
};
